var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, Suspense } from 'react';
import { Flex } from '@chakra-ui/react';
import { StyledBEIcon } from './StyledBEIcon';
import { NebulaIconWrapper } from './NebulaIconWrapper';
import { NebulaIconNames } from './NebulaIconNames';
import { isBEIcon } from './icons';
const FontAwesomeWrapper = React.lazy(() => import(/* webpackChunkName: "icons" */ './FontAwesomeWrapper'));
const NEBULA_ICON_NAMES_VALUES = Object.values(NebulaIconNames);
const isNebulaIconName = (name) => {
    return NEBULA_ICON_NAMES_VALUES.includes(name);
};
// forwardRef is needed for when we need the BEIcon to trigger a tooltip
const BEIcon = forwardRef((_a, ref) => {
    var { center = true, name, color, id, isNebulaIcon = false, size = 'md', testid } = _a, rest = __rest(_a, ["center", "name", "color", "id", "isNebulaIcon", "size", "testid"]);
    return (_jsx(Suspense, { children: _jsx(Flex, { align: center ? 'center' : 'flex-start', color: color, "data-testid": testid, flexShrink: 0, justify: center ? 'center' : 'flex-start', py: isNebulaIcon ? '2px' : '0px', children: isNebulaIcon && isNebulaIconName(name) ? (_jsx(NebulaIconWrapper, Object.assign({ color: color, name: name, size: size }, rest))) : isBEIcon(name) ? (_jsx(StyledBEIcon, Object.assign({}, rest, { center: center, "data-id": id, ref: ref, size: size, children: _jsx(FontAwesomeWrapper, { name: name }) }))) : null }) }));
});
export default BEIcon;
